export const formatDate = (date: Date): string =>
  date.toLocaleDateString("sv-SE");

export const formatTime = (time: string): string =>
  time.slice(0, 5);
